export default {
  '.MuiFormLabel-asterisk': {
    color: 'error.D10',
  },
  '.MuiInputBase-root.MuiOutlinedInput-root': {
    pr: 0,
  },
};
